import { defineComponent, inject, computed } from '@vue/composition-api';
import { AsyncGogoRouteView, loadGogoLib } from './runtime-loader';
import RuntimeReport from '@/reporter/RuntimeReport';
import { useStore } from '@/store';
import { TYPE, PAGE_TYPE } from '@/loaders/page/consts';
import { useGogoCssReset } from './css-reset-counter';
export default defineComponent({
    name: 'GogoRuntimeRouterView',
    components: {
        AsyncGogoRouteView,
    },
    props: {
        projectId: {
            type: String,
            required: true,
        },
        pageId: {
            type: String,
            required: true,
        },
    },
    setup() {
        const store = useStore();
        const gogoHost = inject('gogoHostRef');
        loadGogoLib('runtime'); // 触发加载 lib - 虽然好像没啥必要但是也搞一下吧
        useGogoCssReset();
        const projectConfig = computed(() => store.state.runtime.project);
        return {
            gogoHost,
            projectConfig,
        };
    },
    data() {
        return {
            reporter: null,
        };
    },
    watch: {
        pageId: {
            handler(newPageId, oldPageId) {
                // 上报pv和pgOut
                const { projectId, env } = window.RUNTIME_CONFIGS;
                if (oldPageId && this.reporter) {
                    this.reporter.pgOut()?.destroy();
                    this.reporter = null;
                }
                this.reporter = new RuntimeReport({
                    projectInfo: {
                        projectId,
                        projectName: this.projectConfig?.name,
                        parentId: this.projectConfig?.parentId,
                    },
                    pageId: newPageId,
                    envId: env,
                    pageInfo: {
                        type: TYPE.AI,
                        pageType: PAGE_TYPE.CONTENT,
                        contentType: 'normal',
                    },
                    reportDimensions: [],
                    agentReport: this.projectConfig?.advanceConfig?.agentReport ?? false,
                });
                this.reporter.pv();
            },
            immediate: true,
        },
    },
});
